import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import "./visitorct.scss";
import Img from "../../img/moha.jpg"
import Swal from 'sweetalert2';
import { collection, getDocs, query, where, addDoc, serverTimestamp, } from 'firebase/firestore';
import { db } from '../../firebase-config';
import moment from 'moment/moment';


export function Visitor() {

    const [eventName, setEventName] = useState("");
    const [Description, setDescription] = useState("");
    const [eventDate, setEventDate] = useState();
    const [DeadLineToReserve, setDeadLineToReserve] = useState();
    const [OrganizerName, setOrganizerName] = useState("");

    const [Name, setName] = useState("");
    const [lastName, setLastName] = useState("");
    const [eventId, setEventId] = useState("");
    const [card, setCard] = useState("");
    const [type, setType] = useState("");
    const url = window.location.pathname.replace("/", "");
    const navigate = useNavigate();
    const [IsFinished, setIsFinished] = useState(false);



    useEffect(() => {
        const handleDeadLine = () => {
            // Validacion de fecha limite
       
            var fechaInicio = moment(new Date());
            var fechaFin = moment(new Date(DeadLineToReserve));


            const diff = fechaFin.diff(fechaInicio, 'days');


            if (diff < 0) {
                Swal.fire({
                    position: 'center',
                    icon: 'info',
                    title: 'Ha caducado la fecha para reservar',
                    showConfirmButton: false,
                    timer: 1600
                })
                setTimeout(() => {
                    console.log("Redirige");
                    navigate('/NotFound');
                }, 1600);

                setIsFinished(true);
                return;
            }
        }
        handleDeadLine();
    }, [DeadLineToReserve])


    const handleSubmit = async (e) => {
        e.preventDefault();

        const data = {
            name: Name,
            lastName: lastName,
            eventId: eventId,
            card: card,
            type: type,
        }


        if (Name === '' || lastName === '') {
            Swal.fire({
                position: 'center',
                icon: 'warning',
                title: 'El campo debe ser llenado por un nombre y apellido',
                showConfirmButton: false,
                timer: 1600
            })
            return;
        }

        if (type === "") {
            Swal.fire({
                position: 'center',
                icon: 'warning',
                title: 'Debe seleccionar su alimento esperado',
                showConfirmButton: false,
                timer: 1600
            })
            return;
        }

        if (card === "") {
            Swal.fire({
                position: 'center',
                icon: 'warning',
                title: 'Debe seleccionar su edad',
                showConfirmButton: false,
                timer: 1600
            })
            return;
        }

        try {

            await addDoc(collection(db, "visitors"), {
                data,
                timeStamp: serverTimestamp(),
            });

            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Registrado correctamente',
                showConfirmButton: false,
                timer: 1600
            })

            setTimeout(() => {
                window.location.reload();
            }, 1600);

        } catch (err) {
            Swal.fire({
                position: 'center',
                icon: 'warning',
                title: 'Hubo un problema',
                showConfirmButton: false,
                timer: 1600
            })
        }

    };

    useEffect(() => {
        const getEvents = async () => {
            try {

                // Get event by name
                const eventQuery = query(collection(db, "events"),
                    where("name", ">=", url)
                    , where("name", "<=", url));

                const eventData = await getDocs(eventQuery);
                let eventList = [];
                eventData.docs.forEach((doc) => {
                    eventList.push({ id: doc.id, ...doc.data() });
                });
                // setEvent(...eventList);

                if (eventList.length > 0) {
                    setEventName(eventList[0].name);
                    setDescription(eventList[0].description);
                    setEventDate(eventList[0].eventDate)
                    setDeadLineToReserve(eventList[0].deadLineToReserve)
                    setOrganizerName(eventList[0].organizerName);
                    setEventId(eventList[0].id);
                } else {
                    navigate("/");

                }
            } catch (err) {
                navigate("/ss");
            }
        };
        getEvents();
    }, [url, navigate]);
    return (
        <form className="homeContainer1" >

            <div className="desc">
                <span className='titulo'>{eventName.toUpperCase().replace(/-/g, ' ')}</span>
                <span className='descrip'>{OrganizerName}</span>
                <span className='descrip'>{Description}</span>
                <span className='descrip'>Inicio de la Reserva: {eventDate}</span>
                <span className='descrip'>Fin de la Reserva: {DeadLineToReserve}</span>
                <img src={Img} alt="" className='vector'></img>
            </div>

            <div className='caja'>
                <div className="widgets">
                    <label htmlFor='name'>Apellidos</label>
                    <input type="text" name='lastName' className='formulario' placeholder='Apellidos...' onChange={(e) => setLastName(e.target.value)} />
                </div>
                <div className="widgets">
                    <label htmlFor='nombre'>Nombres</label>
                    <input type="text" name='Name' className='formulario' placeholder='Nombres...' onChange={(e) => setName(e.target.value)} />
                </div>
                <div className="widgets">
                    <label>Elegir Menu</label>
                    <select defaultValue={'Seleccione'} onChange={(e) => setType(e.target.value)}>
                        <option value="Seleccione" disabled>Seleccione</option>
                        <option value="Anfitrion">Anfitrion</option>
                        <option value="Vegetariano">Vegetariano</option>
                        <option value="Celíaco">Celíaco</option>
                    </select>
                </div>
                <div className="widgets">
                    <label>Tipo de Tarjeta</label>
                    <select defaultValue={'Seleccione'} onChange={(e) => setCard(e.target.value)}>
                        <option value="Seleccione" disabled>Seleccione</option>
                        <option value="Adulto">Adulto</option>
                        <option value="Adolescente">Adolescente</option>
                        <option value="Niño">Niño</option>
                    </select>
                </div>
            </div>
            <div>
                <button type="button" onClick={(e) => handleSubmit(e)}>Reservar</button>
            </div>
        </form>
    )
}

export default Visitor